import React from 'react';
import styles from './ModalBrowser.module.scss'

function ModalBrowser({url, title}: {url: string, title?: string}) {

  return (
    <div className={styles.wrapper}>
      <iframe className={styles.iframe} src={url} title={title??"Embedded Page"} />
    </div>
  );
}

export default ModalBrowser;

